/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "./layout.css"
import NavBar from "./organisms/navBar"

import Offer from "./organisms/offer"
import OfferMobile from "./organisms/offerMobile"

import Footer from "./organisms/footer"
import FooterMobile from "./organisms/footerMobile"

import { Show, Stack, Image, VStack, Text, Flex } from "@chakra-ui/react"

import scrollTopImage from "../images/scroll-top.png"
import scrollTopSVGImage from "../images/scroll-top.svg"

import ScrollToTop from "./atoms/scrollUp";

import bgDecoration from "../images/bg-decoration.png"
import BackImage from "../components/atoms/backImage";

const Layout = ({children, path }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <>
      <NavBar></NavBar>
      <Stack h={'64px'}></Stack>
      <main>{children}</main>
        <VStack bgColor={'gray.30'} w={'full'}  px={'2rem'}>
            <ScrollToTop showUnder={0} style={{
              cursor: 'pointer',
              transitionDuration: '0.2s',
              transitionTimingFunction: 'linear',
              transitionDelay: '0s'
          }}>
            <VStack spacing={{base: '1rem', md: '2rem'}} my={'4rem'}>
              <Image src={scrollTopImage} w={{base: '44px', md: '66px'}}/>
              <Text color={'blue'} fontWeight={'bold'} fontSize={{ base: 'md',  md: '2xl'}}>ページトップへ戻る</Text>
            </VStack>
          </ScrollToTop>
        </VStack>
        <ScrollToTop showUnder={0} style={{
          position: 'fixed',
          bottom: 20,
          right: 'auto',
          left: 20,
          cursor: 'pointer',
          transitionDuration: '0.2s',
          transitionTimingFunction: 'linear',
          transitionDelay: '0s',
          zIndex: '30'
      }}>
        <Flex h={'44px'} w={'44px'} bgColor={'blue'} justify={'center'} align={'center'} zIndex={'30'}>
          <Image src={scrollTopSVGImage} mt={2}/>
        </Flex>
      </ScrollToTop> 
      <BackImage showUnder={300} style={{
          position: 'fixed',
          bottom: 0,
          right: 'auto',
          left: 0,
          zindex: '10'
        }}>
        <Flex w={'full'} justify={'center'} align={'center'}>
          <Image src={bgDecoration}/>
        </Flex>
      </BackImage>     
      <Show below="md">
        <OfferMobile />
      </Show>
      <Show above="md">
        <Offer />
      </Show>
      <Show below="md">
        <FooterMobile />
      </Show>
      <Show above="md">
        <Footer />  
      </Show>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
